import merge from 'lodash/merge';

export default function() {
  const defaultConfig = {
    chart: {
      plotBackgroundColor: 'none',
      plotBorderWidth: 0,
      plotShadow: false,
      width: 300,
      backgroundColor: 'none',
      style: {
        fontFamily: 'Roboto'
      }
    },

    tooltip: {
      pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
    },
    legend: {
      align: 'left',
      verticalAlign: 'top',
      layout: 'vertical',
      x: 0,
      y: 0
    },
    plotOptions: {
      pie: {
        showInLegend: false,
        dataLabels: {
          enabled: false,
          distance: 0,
          style: {
            fontWeight: 'bold',
            color: '#000000'
          }
        },
        startAngle: 0,
        endAngle: 360,
        center: ['60%', '40%'],
        size: 150
      }
    },
    credits: {
      enabled: false
    },
    series: []
  };

  return {
    getDefaultConfig: function() {
      return Object.assign({}, defaultConfig);
    },
    initializeWithOptions: function(options) {
      return merge(Object.assign({}, defaultConfig), options);
    }
  };
}



// WEBPACK FOOTER //
// ./src/highchartsConfigDefault/circleDonutConfig.js